import * as types from "./actionTypes.js";
import * as mealApi from '../../api/mealApi.js';


export function addMeal(parameters) {
  return function(dispatch) {
      return mealApi
          .createMeal(parameters)
          .then(meal => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.ADD_MEAL_SUCCESS,
                  meal
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function editMeal(parameters) {
    return function(dispatch) {
        return mealApi
            .updateMeal(parameters)
            .then(meal => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.EDIT_MEAL_SUCCESS,
                    meal
                });
            })
            .catch(error => {
                throw error;
            });
    };
  }

export function fetchMeal(parameters) {
    return function(dispatch) {
        return mealApi
            .getMeal(parameters)
            .then(meal => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.FETCH_MEAL_SUCCESS,
                    meal
                });
            })
            .catch(error => {
                throw error;
            });
    };
  }

  export function removeMeal(parameters) {
    return function(dispatch) {
        return mealApi
            .deleteMeal(parameters)
            .then(response => {
                // separate action creator for successfull api call
                dispatch({
                    type: types.REMOVE_MEAL_SUCCESS,
                    response
                });
            })
            .catch(error => {
                throw error;
            });
    };
  }
